import * as Yup from 'yup';

import { FilterOperations, FilterTypes } from './types';

const getTypeValidation = (messageSingleElement: string) =>
  Yup.string().when('type', (type) => {
    if (!type) {
      return Yup.mixed().notRequired();
    }
    if (type === FilterOperations.OneOf || type === FilterOperations.NotOneOf) {
      return Yup.array().of(Yup.string()).required('You must select at least one.');
    }

    return Yup.string().required(messageSingleElement);
  });

export const validationSchema = Yup.object().shape({
  type: Yup.string().required('Must specify a type'),
  operation: Yup.object({
    type: Yup.string().required('Please select an operation'),
  }).when('type', (type, schema) => {
    switch (type) {
      case FilterTypes.UserId:
        return Yup.object({
          ...schema.fields,
          operand: getTypeValidation('Please select an user id'),
        });
      case FilterTypes.UserEmail:
        return Yup.object({
          ...schema.fields,
          operand: getTypeValidation('Please enter an email value'),
        });
      case FilterTypes.SegmentId:
        return Yup.object({
          ...schema.fields,
          operand: getTypeValidation('Please select a Segment'),
        });
      case FilterTypes.ContentId:
        return Yup.object({
          ...schema.fields,
          operand: getTypeValidation('Please select a Content'),
        });
      case FilterTypes.Host:
        return Yup.object({
          ...schema.fields,
          operand: getTypeValidation('Please enter a URL Domain'),
        });
      case FilterTypes.Pathname:
        return Yup.object({
          ...schema.fields,
          operand: getTypeValidation('Please enter a URL Path'),
        });
      default:
        return Yup.object({ ...schema.fields, operand: getTypeValidation('Please enter a value') });
    }
  }),
  traitName: Yup.string().when('type', (type, schema) =>
    type === FilterTypes.UserProperty
      ? schema.required('Please select a trait')
      : Yup.mixed().notRequired(),
  ),
});
